import { render, staticRenderFns } from "./doorSetting.vue?vue&type=template&id=0925ecb6"
import script from "./doorSetting.vue?vue&type=script&lang=js"
export * from "./doorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports